//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CompanyList',
  props: {
    jobList: { type: Array, default: () => {} },
    total: { type: Number, default: 0 },
    pagerInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      sortOptions: [
        {
          value: 'create_time',
          label: '刊登時間',
        },
      ],
      sort: '',
    };
  },
  computed: {
    showPager() {
      if (this.pagerInfo.size > this.pagerInfo.total) return false;
      return true;
    },
  },
  methods: {
    onChangeSort(value) {
      const payload = {
        orderField: value,
        orderSort: 'ASC',
      };
      this.$emit('sortChange', payload);
    },
    handleCurrentChange(current) {
      this.$parent.conditions = {
        ...this.$parent.conditions,
        ...this.pagerInfo,
        current,
      };
    },
  },
};
